import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Textarea from '../../../components/ui/Textarea';

/**
 * Controlled New/Edit Site form modal. All state lives in the parent (Sites.jsx)
 * and is passed in via props; this component only renders the form and forwards
 * events. `register` is the parent's react-hook-form register (for the notes
 * field, which the parent reads via watch on submit).
 */
export default function SiteFormModal({
  isOpen,
  onClose,
  onSubmit,
  formData,
  setFormData,
  register,
  isSubmitting,
  isEditing,
  canManageSites,
}) {
  const update = (field) => (e) => setFormData({ ...formData, [field]: e.target.value });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={isEditing ? 'Edit Site' : 'New Site'}>
      <form onSubmit={onSubmit}>
        <div className="form-row">
          <Input
            id="site-form-name"
            label="Name *"
            className="form-group--wide"
            value={formData.name}
            onChange={update('name')}
            required
            placeholder="e.g. Main Office"
          />
          <Input
            id="site-form-site-code"
            label="Site Code"
            value={formData.siteCode}
            onChange={update('siteCode')}
            placeholder="e.g. 4101"
          />
        </div>

        <Input
          id="site-form-address"
          label="Address"
          value={formData.address}
          onChange={update('address')}
        />
        <Textarea
          id="site-form-notes"
          label="Notes"
          {...register('notes')}
          rows={3}
          placeholder="Site notes (optional)"
        />
        <div className="form-row">
          <Input
            id="site-form-city"
            label="City"
            value={formData.city}
            onChange={update('city')}
          />
          <Input
            id="site-form-state"
            label="State"
            value={formData.state}
            onChange={update('state')}
          />
          <Input
            id="site-form-postcode"
            label="Postcode"
            value={formData.postcode}
            onChange={update('postcode')}
          />
        </div>
        <Input
          id="site-form-contact-name"
          label="Contact Name"
          value={formData.contactName}
          onChange={update('contactName')}
        />
        <div className="form-row">
          <Input
            id="site-form-contact-phone"
            label="Contact Phone"
            value={formData.contactPhone}
            onChange={update('contactPhone')}
          />
          <Input
            id="site-form-contact-email"
            label="Contact Email"
            type="email"
            value={formData.contactEmail}
            onChange={update('contactEmail')}
          />
        </div>
        {canManageSites && (
          <div className="form-group">
            <label htmlFor="site-form-master-testing-date">Master Testing Date</label>
            <input
              id="site-form-master-testing-date"
              type="date"
              value={formData.testingDueDate}
              onChange={update('testingDueDate')}
              title="Anchor date for this site; asset next-test dates can be calculated from this."
            />
            <span className="form-hint">Optional. When set, asset due dates are derived from this date by type (e.g. RCD +12m, Exit lights +6m).</span>
          </div>
        )}
        <div className="form-actions">
          <Button type="button" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={isSubmitting}>
            {isSubmitting ? 'Updating…' : (isEditing ? 'Update' : 'Create')}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
